import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction('propertyAvailability/SET_LOADING');
export const fetchPropertyAvailability = createAction('propertyAvailability/FETCH_PROPERTY_AVAILABILITY');
export const fetchPropertyAvailabilitySuccess = createAction('propertyAvailability/FETCH_PROPERTY_AVAILABILITY_SUCCESS');
export const fetchPropertyAvailabilityFailure = createAction<unknown>('propertyAvailability/FETCH_PROPERTY_AVAILABILITY_FAILURE');
export const clearResults = createAction('propertyAvailability/CLEAR_RESULTS');
export const updateQuery = createAction('propertyAvailability/UPDATE_QUERY');
export const emitPropertyPageStandardGa4Event = createAction('propertyAvailability/EMIT_PROPERTY_STANDARD_OFFER_ROOM_RESULTS');
